import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from './store'
import { zoomSdkApi } from './zoomSdkQueries'

type Canvas = {
  videoOn: boolean
  size: {
    width: number
    height: number
  }
}

const initialState: Canvas = {
  size: {
    width: 1280,
    height: 720,
  },
  videoOn: false,
}

const canvasSlice = createSlice({
  name: 'canvas',
  initialState,
  reducers: {
    setVideoOn: (state, { payload }: PayloadAction<boolean>) => {
      state.videoOn = payload
    },
    setSize: (state, { payload }: PayloadAction<Canvas['size']>) => {
      state.size = payload
    },
  },
  // allows config values to be initial state for the canvas reducer
  extraReducers: (builder) => {
    builder.addMatcher(
      zoomSdkApi.endpoints.config.matchFulfilled,
      (state, { payload: { media } }) => {
        if (media?.video?.height) {
          state.size = {
            height: media.video.height,
            width: media.video.width,
          }
          state.videoOn = true
        }
      }
    )
  },
})

export const { setVideoOn, setSize } = canvasSlice.actions

export const selectSize = (state: RootState) => state.canvas.size
export const selectVideoOn = (state: RootState) => state.canvas.videoOn

export default canvasSlice
